
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Music2, Mic, Drum } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Index = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-black p-4">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl w-full">
        <Card className="bg-card border-border hover:bg-accent/50 transition-colors cursor-pointer"
              onClick={() => navigate('/ai-stem-splitter')}>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Music2 className="h-6 w-6" />
              AI Stem Splitter
            </CardTitle>
            <CardDescription>
              Split your music into separate instrument tracks
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Button variant="outline" className="w-full">
              Get Started
            </Button>
          </CardContent>
        </Card>

        <Card className="bg-card border-border hover:bg-accent/50 transition-colors cursor-pointer"
              onClick={() => navigate('/acapella-extractor')}>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Mic className="h-6 w-6" />
              Acapella Extractor
            </CardTitle>
            <CardDescription>
              Extract vocals from your music
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Button variant="outline" className="w-full">
              Get Started
            </Button>
          </CardContent>
        </Card>

        <Card className="bg-card border-border hover:bg-accent/50 transition-colors cursor-pointer"
              onClick={() => navigate('/drum-remover')}>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Drum className="h-6 w-6" />
              Drum Remover
            </CardTitle>
            <CardDescription>
              Extract and remove drums from your music
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Button variant="outline" className="w-full">
              Get Started
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Index;
